<template lang="pug">
    .container(
        :style='{height: `${gallery.length*150}vh`}',
        ref='container'
        )
        .animated-scroll(
            ref='animatedScroll' 
            )
            .gallery-container(ref='galleryContainer')
                .gallery(ref='gallery')

                    .gallery-item-wrap(v-for='item in gallery', :key='item.title')

                        .gallery-item(ref='galleryItem')
                            .gallery-item__content(ref='gallerySlide')

                                .gallery-item__bg(ref='gallerySlideBg')

                                .gallery-item__img-wrap(ref='gallerySlideImgWrp')
                                    img(
                                        :src='require(`../../assets/img/gallery/${item.name}.jpg`)',
                                        loading='lazy',
                                        :title='item.title',
                                        ref='img'
                                        )

                                .gallery-item__title-wrap(ref='gallerySlideTtlWrp')
                                    span.gallery-item__title(
                                        v-html='item.title',
                                        ref='gallerySlideTtl'
                                        )

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

export default {
    data() {
        return {
            innerBlockPosition: 'top',
            isControlScroll: true
        };
    },
    props: {
        gallery: Array,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});

            this.timeline
                .set(this.$refs.gallerySlideBg, {scaleY: 0, scaleX: 1})
                .set(this.$refs.gallerySlideImgWrp, {opacity: 0})
                .set(this.$refs.gallerySlideTtlWrp, {opacity: 0})
                .set(this.$refs.gallerySlideTtl, {x: '-100%'})
                .fromTo(this.$refs.galleryItem, {x: '150%'}, {duration: 3, x: '-150%', ease: 'none', stagger: {each: 1}}, 0)
                .to(this.$refs.gallerySlideBg, {transformOrigin: '0 100%', duration: 0.4, scaleY: 1, scaleX: 1, ease: 'none', stagger: {each: 1}}, 0)
                .set(this.$refs.gallerySlideTtlWrp, {opacity: 1, ease: 'none', stagger: {each: 1}}, 0.4)
                .set(this.$refs.gallerySlideImgWrp, {opacity: 1, ease: 'none', stagger: {each: 1}}, 0.4)
                .to(this.$refs.gallerySlideBg, {transformOrigin: '0 100%', scaleY: 0, duration: 0.4, ease: 'none', scaleX: 1, stagger: {each: 1}}, 0.4)
                .to(this.$refs.gallerySlideTtl, {x: 0, duration: 0.2, ease: 'none', stagger: {each: 1}}, 0.8)
                .to(this.$refs.gallerySlideBg, {transformOrigin: '0 100%', ease: 'none', scaleY: 1, delay: 1, duration: 0.5, scaleX: 1, stagger: {each: 1}}, 1)
                .set(this.$refs.gallerySlideTtlWrp, {opacity: 0, ease: 'none', stagger: {each: 1}}, 2.5)
                .set(this.$refs.gallerySlideImgWrp, {opacity: 0, ease: 'none', stagger: {each: 1}}, 2.5)
                .to(this.$refs.gallerySlideBg, {transformOrigin: '0 0', scaleY: 0, ease: 'none', duration: 0.5, stagger: {each: 1}}, 2.5);

            this.timeline.progress(0.0001);
        },
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-middle', 'bottom-top');
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.container {
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    height: 100vh;
    width: 100%;
    background-color: #000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;

    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }

    &.bottom {
        bottom: 0;
        top: auto;
    }
}

.gallery-container {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
}

.gallery {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
}
.gallery-item-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.gallery-item {
    padding: 0 var(--grid-column);
    display: flex;
    align-items: center;
    @media (--viewport-tablet) {
        padding: 0 var(--grid-column-mobile);
        width: calc(var(--grid-column-mobile) * 11);
    }
    @media (--viewport-mobile-lp) {
        width: fit-content;
    }

    &__bg {
        width: 100%;
        height: 100%;
        background: var(--theme);
        position: absolute;
        top: 0;
        left: 0;
        will-change: transform;
        z-index: 1;
    }

    &__content {
        // width: calc(var(--grid-column) * 6);
        position: relative;
        overflow: hidden;

        @media screen and (--viewport-tablet) {
            // width: 100vw;
        }
    }

    &__img-wrap {
        img {
            @media screen and (--viewport-tablet) {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
            @media (--viewport-mobile-lp) {
                max-height: calc(85 * var(--vh) - 56px);
                object-fit: contain;
            }
        }
    }

    &__title-wrap {
        background: var(--theme);
        font-size: 1rem;
        line-height: 1.125;
        opacity: 0;
    }

    &__title {
        padding: 0.625rem 4px;
        font-size: 1rem;
        line-height: 1.125;
        display: block;
        transform: translateX(-100%);
        color: black;
    }
}
</style>
